export default __webpack_public_path__ + "static/media/default.84fa46fb.jpg";